import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldBase } from '../../../../../model/forms/FieldBase';

@Component({
	templateUrl: './color-field.component.html',
	styleUrls: ['./color-field.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorFieldComponent extends FieldBase<string> { }